import type { TagProps } from '@iheartjane/reefer';
import { JaneGoldIcon, Tag } from '@iheartjane/reefer';
import { clsx } from 'clsx';

import { useKioskSpacing } from '@jane/kiosk/hooks';
import { useComplianceLanguage } from '@jane/kiosk/providers';
import { capitalize } from '@jane/kiosk/util';
import { truncateLabel } from '@jane/shared-ecomm/util';

import styles from './dealTag.module.css';

interface DealTagProps extends Partial<TagProps> {
  isGold?: boolean;
  maxLabelLength?: number;
  tagLabel: string | null;
}

export const DealTag = ({
  isGold,
  maxLabelLength = 12,
  tagLabel,
  ...props
}: DealTagProps) => {
  const { isIpad } = useKioskSpacing();
  const { getWord } = useComplianceLanguage();
  return (
    <Tag
      className={clsx(styles['dealTag'], {
        [styles['paddedTag']]: !isIpad,
      })}
      background={isGold ? 'gold' : 'sunset'}
      color={isGold ? 'grays-black' : 'grays-white'}
      label={truncateLabel(
        tagLabel ? tagLabel : capitalize(getWord('deals_badge') ?? 'Deal'),
        maxLabelLength
      )}
      icon={
        isGold ? (
          <div>
            <JaneGoldIcon size="sm" />
          </div>
        ) : undefined
      }
      size="sm"
      {...props}
    />
  );
};
